/**
 * Central config for the GenieBot ecosystem bar.
 * Update domain labels, URLs, cover images, or the "active" entry here.
 */
import geniebotPro from "@/assets/ecosystem/geniebot-pro.png";
import geniebotShop from "@/assets/ecosystem/geniebot-shop.png";
import geniebotVip from "@/assets/ecosystem/geniebot-vip.png";
import geniebotStore from "@/assets/ecosystem/geniebot-store.png";
import geniebotBiz from "@/assets/ecosystem/geniebot-biz.png";
import geniebotWorld from "@/assets/ecosystem/geniebot-world.png";
import geniebotClub from "@/assets/ecosystem/geniebot-club.png";

export type EcosystemLink = {
  label: string;
  href: string;
  /** Cover screenshot of the destination site. */
  cover: string;
  /** Short tagline shown under the cover. */
  tagline?: string;
  /** Marks the current site — rendered as non-clickable. */
  active?: boolean;
};

export const ecosystemLinks: EcosystemLink[] = [
  {
    label: "GenieBot",
    href: "https://geniebot.pro",
    cover: geniebotPro,
    tagline: "One AI Platform",
    active: true,
  },
  {
    label: "GenieBot",
    href: "https://geniebot.shop",
    cover: geniebotShop,
    tagline: "Event Galleries",
  },
  {
    label: "GenieBot",
    href: "https://geniebot.vip",
    cover: geniebotVip,
    tagline: "AfterText",
  },
  {
    label: "GenieBot",
    href: "https://geniebot.store",
    cover: geniebotStore,
    tagline: "AI System Prompts",
  },
  {
    label: "GenieBot",
    href: "https://geniebot.biz",
    cover: geniebotBiz,
    tagline: "Legal Workflows",
  },
  {
    label: "GenieBot",
    href: "https://geniebot.world",
    cover: geniebotWorld,
    tagline: "Aesthetic Scan",
  },
  {
    label: "GenieBot",
    href: "https://geniebot.club",
    cover: geniebotClub,
    tagline: "WildWise",
  },
];
